import { availableLanguages } from '../constants/languages';

interface Language {
  id: string;
  default?: boolean;
}

export const getDefaultLanguage = (): Language => {
  const result = availableLanguages.filter((lg: Language) => lg.default);
  return result.length >= 1 ? result[0] : availableLanguages[0];
};

export const findLanguageById = (languageId: string): Language => {
  const result = availableLanguages.filter(
    (lg: Language) => lg.id === languageId
  );
  return result.length >= 1 ? result[0] : availableLanguages[0];
};
